var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { ConfirmationDialogModel } from '../../../../models/lookups/lookup.models';
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
var ConfirmModal = /** @class */ (function () {
    function ConfirmModal(dialogClient) {
        this.dialogClient = dialogClient;
    }
    ConfirmModal.prototype.activate = function (vm) {
        this._vm = vm;
        this._disableActions = false;
        if (this._vm.confirmModel)
            this.confirmModel = this._vm.confirmModel;
        else
            this.confirmModel = new ConfirmationDialogModel();
    };
    ConfirmModal.prototype.yes = function () {
        var _this = this;
        return new Promise(function (resolves, reject) {
            try {
                _this._disableActions = true;
                var response = _this._vm.save();
                if (response instanceof Promise) {
                    response
                        .then(function (x) {
                        _this._disableActions = false;
                        resolves(x);
                    })
                        .catch(function (ex) {
                        _this._disableActions = false;
                        reject(ex);
                    });
                }
                else {
                    _this._disableActions = false;
                    resolves(response);
                }
            }
            catch (ex) {
                _this._disableActions = false;
                reject();
            }
        });
    };
    ConfirmModal.prototype.no = function () {
        // if there is any function mention on 'no', make response back on dialog hide 
        //(this is especially used for 2nd dialog open overlap on 1st dialog, so when click no only 2nd dialog will hide)
        // we just differentiating the 1st dialog without function and 2nd dialog with function, example, it is used in manage-lotteries-dialog.ts
        if (this._vm.hide && typeof this._vm.hide === 'function') {
            this._vm.hide();
        }
        else {
            this.dialogClient.hide();
        }
    };
    ConfirmModal = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService])
    ], ConfirmModal);
    return ConfirmModal;
}());
export { ConfirmModal };
